<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .add-file-header {
    @include mixins.h3();
  }
</style>

<script>
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import { activePopUpModalStore } from "../../stores";
  import FileUploadForm from "./FileUploadForm.svelte";

  const closeModal = () => {
    activePopUpModalStore.set(null);
  };
</script>

<Modal onclose={closeModal} size="small">
  <span class="add-file-header" slot="header">Add Files</span>
  <FileUploadForm {closeModal} />
</Modal>
